import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@wds/grid';
import { List } from '@wds/list';

export const ByNeedColumn = ({ children }) => {
  return (
    <Grid.Item>
      <div className="sm-nav-submenu__col">
        <List transparent noRules>
          {children}
        </List>
      </div>
    </Grid.Item>
  );
};

export default ByNeedColumn;

ByNeedColumn.propTypes = {
  children: PropTypes.node.isRequired,
};
